import React from "react";
import { Modal, Row, Col, Form, Table } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import "./ServicePackageModal.css";

export default function ServicePackageModal({ show, onHide, vehicle }) {
    const service = vehicle?.servicePackages;

    if (!service) return null;

    const variants = service.variants || [];
    const mileageOptions = service.mileageOptions || [];
    const prices = service.prices || {};

    const validationSchema = Yup.object().shape({
        variant: Yup.string()
            .required("Please select a variant.")
            .notOneOf([""], "Please select a variant."),
        mileage: Yup.string()
            .required("Please select mileage.")
            .notOneOf([""], "Please select mileage.")
    });

    return (
        <Modal show={show} onHide={onHide} centered size="lg">
            <Modal.Header closeButton className="brand-modal-header">
            </Modal.Header>

            <Formik
                initialValues={{ variant: "", mileage: "" }}
                validationSchema={validationSchema}
                onSubmit={() => { }}
            >
                {({
                    values,
                    handleChange,
                    handleBlur,
                    errors,
                    touched,
                    setFieldValue
                }) => {
                    const variantSelected = Boolean(values.variant);
                    const mileageSelected = Boolean(values.mileage);

                    const price =
                        variantSelected && mileageSelected
                            ? prices?.[values.variant]?.[values.mileage] || "—"
                            : null;

                    // Build table rows based on selected variant (all mileage options + price)
                    const selectedVariantTableRows = variantSelected
                        ? mileageOptions.map((m) => ({
                            mileage: m,
                            price: prices?.[values.variant]?.[m] || "—"
                        }))
                        : [];

                    return (
                        <Form>
                            <Modal.Body>
                                <h4 className="servicePackageModal-title">Service Package</h4>
                                <Row className="align-items-center mb-3">
                                    {vehicle.imageSrc && (
                                        <img
                                            src={vehicle.imageSrc}
                                            alt={vehicle.title}
                                            className="service-modal__vehicle-image"
                                        />
                                    )}


                                    <div className="text-center">
                                        <h5 className="service-modal__vehicle-title">
                                            {vehicle.title}
                                        </h5>

                                        <p class="servicePackage-modal__inclusive-text">Inclusive of VAT*</p>

                                    </div>

                                    <Row className="g-3 mt-1">
                                        
                                        <Col xs={12} md={6}>
                                            <Form.Group controlId="variant">
                                                <Form.Label className="brand-input-label">Select Variant</Form.Label>
                                                <Form.Select className="brand-input"
                                                    name="variant"
                                                    value={values.variant}
                                                    onChange={(e) => {
                                                        handleChange(e);

                                                        // 🔥 reset mileage when variant changes
                                                        setFieldValue("mileage", "");
                                                    }}
                                                    onBlur={handleBlur}
                                                >
                                                    <option value="">Select Variant</option>
                                                    {variants.map((v) => (
                                                        <option key={v} value={v}>
                                                            {v}
                                                        </option>
                                                    ))}
                                                </Form.Select>

                                                {errors.variant && touched.variant && (
                                                    <div className="service-modal__error">
                                                        {errors.variant}
                                                    </div>
                                                )}
                                            </Form.Group>
                                        </Col>

                                        {/* Mileage */}
                                        <Col xs={12} md={6}>
                                            <Form.Group controlId="mileage">
                                                <Form.Label className="brand-input-label">Select Mileage</Form.Label>
                                                <Form.Select className="brand-input"
                                                    name="mileage"
                                                    value={values.mileage}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    disabled={!variantSelected}
                                                >
                                                    <option value="">Select Mileage</option>
                                                    {mileageOptions.map((m) => (
                                                        <option key={m} value={m}>
                                                            {m}
                                                        </option>
                                                    ))}
                                                </Form.Select>

                                                {errors.mileage && touched.mileage && (
                                                    <div className="service-modal__error">
                                                        {errors.mileage}
                                                    </div>
                                                )}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Row>

                                {/* ✅ Price Line: show only when both selected */}
                                {variantSelected && mileageSelected && (
                                    <div className="service-modal__price-line">
                                        Service Cost of your{" "}
                                        <strong>{values.variant}</strong> for{" "}
                                        <strong>{values.mileage}</strong> will be{" "}
                                        <strong>{price}</strong>.
                                    </div>
                                )}

                                {/* ✅ Table: show once variant selected (and update as per selected variant) */}
                                {variantSelected && mileageSelected && (
                                    <div className="service-modal__table-wrap">
                                        <Table responsive bordered hover size="sm" className="mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Mileage</th>
                                                    <th>Service Price</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {selectedVariantTableRows.map((row) => (
                                                    <tr key={row.mileage}>
                                                        <td>{row.mileage}</td>
                                                        <td>{row.price}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                )}
                            </Modal.Body>
                        </Form>
                    );
                }}
            </Formik>
        </Modal>
    );
}
